import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import * as fromRootStore from '@apps/root/store';
import { IAuroraState } from '@apps/aurora.state';

import { PopupMenuItem } from '../cog/popup-menu-item.model';


@Component({
    selector: 'aa-popup-menu-item',
    templateUrl: './popup-menu-item.component.html',
    styleUrls: [
        './popup-menu-item.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupMenuItemComponent implements OnInit
{
    @Input() popupMenuItem: PopupMenuItem;
    @Input() typePopup: string;
    text: string;

    constructor (
        private translate: TranslateService,
        private store: Store<IAuroraState>
    )
    { }

    ngOnInit ()
    {
        this.text = this.translate.instant(this.popupMenuItem.key);
    }

    ctaClick ()
    {
        this.popupMenuItem.cta();
        this.store.dispatch(fromRootStore.RootMiscStoreActions.RootPopupMenuItemClicked());
    }

    linkClick ()
    {
        this.store.dispatch(fromRootStore.RootMiscStoreActions.RootPopupMenuItemClicked());
    }
}
